<div class="page-title-area item-bg1">
    <div class="container">
        <app-background-animation></app-background-animation>
        <div class="page-title-content">
            <p class="fs-3 color-white text-center glowing-heading">Blogs</p>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</div>

<!--<section class="blog-details-area ptb-110">

    <div class="container">
        <div class="row">
            &lt;!&ndash; Left Sidebar with Headings &ndash;&gt;
            <div class="col-12 col-md-3">
                <div class="nav flex-column  shadow rounded border-0 h-auto ">
                    <a
                        class="nav-link text-black"
                        *ngFor="let heading of headings; let i = index"
                        (click)="scrollToSection(i)"
                        [id]="'sidebar-link-' + i">
                        {{ heading }}
                    </a>
                </div>
            </div>

            &lt;!&ndash; Right Content Area &ndash;&gt;
            <div class="col-12 col-md-9">
                <div>
                    <div class="article-image mb-3">
                        <img src="{{selectedData?.blog_banner?.url}}" alt="image">
                    </div>
                    <h2 style="color: #5236ff;">{{ selectedData.heading }}</h2>
                    <div [innerHTML]="selectedData.content"></div>
                </div>

                <div class="mt-5 mb-2" *ngFor="let section of selectedData?.blog_details; let i = index" [id]="'section-' + i">
                    <div (click)="scrollToSection(section.id)">
                        <hr style="border-top: 3px dashed #5236ff;width: 20%;" />
                        <h1 style="color: #5236ff;">{{ section.heading }}</h1>
                        <div [innerHTML]="section?.content"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>-->

<section class="blog-details-area ptb-110 content">
    <div class="container">
        <div class="row">
            <!-- Left Sidebar with Headings -->
            <div class="col-12 d-none d-md-block col-md-3">
                <div class=" shadow rounded border-0 fixed-navigation-card">

                    <a
                        class="nav-link border-bottom text-black fs-6 a-tag m-0 p-2"
                        *ngFor="let heading of headings; let i = index"
                        (click)="scrollToSection(i)"
                        [id]="'sidebar-link-' + i">
                         {{ heading }}
                    </a>
                </div>
            </div>

            <!-- Right Content Area -->
            <div class="col-12 col-md-9 h-100  content-section" id="right-section">
                <div>
                    <div class="article-image mb-3 h-100 " style="margin-top: 50px">
                        <img src="{{ selectedData?.blog_banner?.url }}" alt="image"/>
                    </div>
                    <h1 class="text-black fw-bold" >{{ selectedData?.heading }}</h1>
                    <div [innerHTML]="selectedData?.content"></div>
                </div>

                <div
                    class="mt-3 mb-2 "
                    *ngFor="let section of selectedData?.blog_details; let i = index"
                    [id]="'section-' + i">
                    <div (click)="scrollToSection(section.id)" >
                        <h2 class="text-black fw-bold">{{ section.heading }}</h2>
                        <div class="text-black" [innerHTML]="section?.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="container-fluid mt-5 py-5"
     style="background-image: url('/assets/img/landing-new/footer/footer-bg.png'); background-size: cover">
    <div class="container">
        <div class="row flex-wrap flex-md-nowrap">
            <div class="  col-12  col-md-6 fs-1 color-white fw-bold mb-3 mb-md-0">
                Ready to take your Business’s IT to the next level?
            </div>
            <div class=" col-12  col-md-6 text-md-end align-self-center">
                <button class="bg-F5FCFF px-5 py-3 border-0 fs-6 fw-bold hover-effect" (click)="goTo('/contact')">
                    Contact Us <i class="fa fa-arrow-right" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
</div>
